/**
 * セクショングループ一覧ページ専用i18n定数
 */

export const SECTION_GROUP_LIST_I18N = {
  // ステータス
  status: {
    active: $localize`:@@systemAdmin.sectionGroupList.status.active:有効`,
    inactive: $localize`:@@systemAdmin.sectionGroupList.status.inactive:無効`,
  },

  // ダイアログ
  dialog: {
    confirmTitle: $localize`:@@systemAdmin.sectionGroupList.dialog.confirmTitle:ダイアログ確認`,
    confirmMessage: $localize`:@@systemAdmin.sectionGroupList.dialog.confirmMessage:ダイアログが表示されます`,
  },
} as const;

export type SectionGroupListI18n = typeof SECTION_GROUP_LIST_I18N;
